import {Strings} from '../../Strings';
import {Utils} from '../../underscore-extensions';

class SubscriptionCurrentPlan implements ng.IComponentController {
    productName = Utils.getProduct().toLocaleLowerCase();
    planName: string;
    nextPaymentValue: string;
    nextPaymentDate: Date;
    switchSave: number;
    expirationDate: number;
    switchPeriod: anm.BillingPeriod;
    planNameText: string;
    onSwitchTo: (period: anm.BillingPeriod) => {};
    onCancel: () => {};

    $onChanges() {
        this.planNameText = this.capitalize(this.planName.toLocaleLowerCase());
    }

    private capitalize(text: string) {
        const textArr = text.split(' ');
        return textArr.reduce((initText, word) => `${initText} ${Strings.capitalize(word)}`, '');
    }
}

angular.module('animatronApp.SubscriptionCurrentPlan', [])
    .component('subscriptionCurrentPlan', {
        bindings: {
            planName: '<',
            nextPaymentValue: '<',
            nextPaymentDate: '<',
            switchPeriod: '<',
            expirationDate: '<',
            switchSave: '<',
            onSwitchTo: '&?',
            onCancel: '&?'
        },
        controller: SubscriptionCurrentPlan,
        templateUrl:
            require('settings/subscription/subscription-current-plan.html')
    })
;



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionCurrentPlan.ts